// similar to ui/Cell without the default padding
import * as React from 'react';
import { Base } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const ForwardCell = props => /*#__PURE__*/_jsx(Base, {
  flexAuto: true,
  flex: true,
  flexAlignItemsCenter: true,
  ...props
});
export default ForwardCell;